class ProjectTabNames {
    public static readonly Project = 'project';
    public static readonly Tab2 = 'tab2';
    public static readonly Tab3 = 'tab3';
    public static readonly Tab4 = 'tab4';
    public static readonly Tab5 = 'tab5';
    public static readonly Sharing = 'sharing';
    public static readonly Assets = 'assets';
    public static readonly Journal = 'journal';
    public static readonly Details = 'details';
    public static readonly Template = 'template';
    public static readonly Admin = 'admin';
}

export default ProjectTabNames;
